<template>
  <div class="efactura-receiver">
    <span class="efactura-receiver-name">{{ data.company_name || '—' }}</span>
    <span class="efactura-receiver-cui">{{ cui }}</span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererReceiver',
  computed: {
    data () {
      return this.params.data || {}
    },
    /** « FIZIC » = personne physique, sans CUI : c'est le bloc d'identité
     *  simplifié qui partira dans le XML. */
    cui () {
      const raw = this.data.cui
      if (!raw || raw === '-') return 'FIZIC'
      return raw.replace('RO', '')
    }
  }
}
</script>

<style scoped>
.efactura-receiver {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.25;
  overflow: hidden;
}

.efactura-receiver-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.efactura-receiver-cui {
  font-size: 0.7rem;
  opacity: 0.6;
}
</style>
